export const ACTIVITY_TYPES = {
	QUOTE_CREATED: 'QUOTE_CREATED',
	CARRIER_INVITED: 'CARRIER_INVITED',
	CARRIER_ACCEPTED: 'CARRIER_ACCEPTED',
	CARRIER_COUNTERED: 'CARRIER_COUNTERED',
	CARRIER_DECLINED: 'CARRIER_DECLINED',
	BOOKING_CREATED: 'BOOKING_CREATED',
	BOOKING_SIGNED: 'BOOKING_SIGNED',
	ALL_BIDS_SENT: 'ALL_BIDS_SENT',
	ASCEND_BID_CREATED: 'ASCEND_BID_CREATED',
	BOOKING_CONFIRMATION: 'BOOKING_CONFIRMATION',
	BROKER_COUNTERED: 'BROKER_COUNTERED',
	NOTIFICATIONS_SCHEDULED: 'NOTIFICATIONS_SCHEDULED',
	PROJECT_MAX_BUY_USED: 'PROJECT_MAX_BUY_USED'
};

export const ACTIVITY_TYPE_MESSAGE = {
	QUOTE_CREATED: 'Quote Created',
	CARRIER_INVITED: 'Offer sent to ',
	CARRIER_ACCEPTED: 'Offer accepted by ',
	CARRIER_COUNTERED: 'Counter offer received from ',
	CARRIER_DECLINED: 'Offer declined by ',
	BOOKING_CREATED: 'Rate confirmation generated for ',
	BOOKING_SIGNED: 'Rate confirmation signed by ',
	ALL_BIDS_SENT: 'All offers sent to carriers',
	ASCEND_BID_CREATED: 'Offer created from Ascend. Offer received from ',
	BOOKING_CONFIRMATION: ' Accepted after Booking Confirmation is submitted',
	NOTIFICATIONS_SCHEDULED: 'All notification groups scheduled',
};
